<template>
  <v-container fluid class="promotion-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Promotion</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Promotion</p>
                        <v-text-field
                          class="mb-4"
                          v-model="promotion.promotioncode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Promotion Code"
                          persistent-hint
                          single-line hint="Enter the promotion code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="promotion.promotionname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Promotion Name"
                          persistent-hint
                          single-line hint="Enter the promotion name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="promotion.promotiontype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the promotion type">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-menu
                          ref="menu_promotiondate"
                          v-model="menu_promotiondate"
                          :close-on-content-click="false"
                          :return-value.sync="promotion.promotiondate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="promotion.promotiondate"
                              label="Promotion Date"
                              v-bind="attrs"
                              v-bind:value="promotion.promotiondate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please enter promotion date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="promotion.promotiondate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_promotiondate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_promotiondate.save(promotion.promotiondate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_promotionstartdate"
                          v-model="menu_promotionstartdate"
                          :close-on-content-click="false"
                          :return-value.sync="promotion.promotionstartdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="promotion.promotionstartdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="promotion.promotionstartdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="promotion.promotionstartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_promotionstartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_promotionstartdate.save(promotion.promotionstartdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_promotionenddate"
                          v-model="menu_promotionenddate"
                          :close-on-content-click="false"
                          :return-value.sync="promotion.promotionenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="promotion.promotionenddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="promotion.promotionenddate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="promotion.promotionenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_promotionenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_promotionenddate.save(promotion.promotionenddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="5">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/promotion/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertPromotion()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      promotion: {},
      items: ['Bundle', 'Discount'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      menu_promotiondate: false,
      menu_promotionstartdate: false,
      menu_promotionenddate: false,
    }
  },

  methods: {
    ...mapActions('Promotion', ['insertPromotionRequest', 'getPromotionsRequest']),
    checkError(){
      if(!this.promotion.promotioncode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.promotion.promotionname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.promotion.promotiontype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async insertPromotion() {
      if(!this.checkError()) return;
      await this.insertPromotionRequest(this.promotion);
      router.push('/promotion/list');
    },
  },
  computed: {
    ...mapState('Promotion', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
